import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 20,
  pageOptions: [20, 50, 100],
  totalRows: 1,
  sortOptions: [],
  fields: [
    { key: 'fullname', label: 'Name', sortable: true },
    { key: 'phone', label: 'phone'},
    { key: 'email', label: 'email'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: [],
  perPageprofession: 20,
  pageOptionsprofession: [20, 50, 100],
  totalRowsprofession: 1,
  sortOptionsprofession: [],
  fieldsprofession: [
    { key: 'fullname', label: 'Name', sortable: true },
    { key: 'phone', label: 'phone'},
    { key: 'email', label: 'email'},
    { key: 'created_at', label: 'Created At'},
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  itemsprofession: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'verification/users/false'}
    useIPA.get(param).then(response => {
      const verification = {
        rows : response.data.data
      }
      commit('setData', {...verification})
    })
  },
  true ({ commit }) {
    let param = {status: 'verification/users/true'}
    useIPA.get(param).then(response => {
      const verification = {
        rows : response.data.data
      }
      commit('setDataTrue', {...verification})
    })
  },
  getAllProfession ({ commit }) {
    let param = {status: 'verification/practitions/false'}
    useIPA.get(param).then(response => {
      const profession = {
        rowsprofession : response.data.data
      }
      commit('setDataProfession', {...profession})
    })
  },
  getAllProfessionTrue ({ commit }) {
    let param = {status: 'verification/practitions/true'}
    useIPA.get(param).then(response => {
      const profession = {
        rowsprofession : response.data.data
      }
      commit('setDataProfessionTrue', {...profession})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'verification/user/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  getByProfessionId ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'verification/practition/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: `dashboard/verification/user/${formData.url}`, id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'verification-su' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  formPostPutProfession ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const param = { rawData: '', url: `dashboard/verification/practition/${formData.url}`, id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'verification-lp' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/profession', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, verification) {
    state.fields = [
      { key: 'fullname', label: 'Name', sortable: true },
      { key: 'phone', label: 'phone'},
      { key: 'email', label: 'email'},
      { key: 'created_at', label: 'Created At'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'}
    ]
    state.items = verification.rows
    state.totalRows = verification.rows.length
  },
  setDataTrue (state, verification) {
    state.fields = [
      { key: 'fullname', label: 'Name', sortable: true },
      { key: 'phone', label: 'phone'},
      { key: 'email', label: 'email'},
      { key: 'created_at', label: 'Created At'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'}
    ]
    state.items = verification.rows
    state.totalRows = verification.rows.length
  },
  setDataProfession (state, profession) {
    state.fieldsprofession = [
      { key: 'fullname', label: 'Name', sortable: true },
      { key: 'phone', label: 'phone'},
      { key: 'email', label: 'email'},
      { key: 'created_at', label: 'Created At'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'},
    ],
    state.itemsprofession = profession.rowsprofession
    state.totalRowsprofession = profession.rowsprofession.length
  },
  setDataProfessionTrue (state, profession) {
    state.fieldsprofession = [
      { key: 'fullname', label: 'Name', sortable: true },
      { key: 'phone', label: 'phone'},
      { key: 'email', label: 'email'},
      { key: 'created_at', label: 'Created At'},
      { key: 'status', label: 'Status', sortable: true },
      { key: 'action', label: 'Action'},
    ],
    state.itemsprofession = profession.rowsprofession
    state.totalRowsprofession = profession.rowsprofession.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
